// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2JhQL","notes":"Notes_notes__2BkJ6","note":"Notes_note__34h7n","markdown":"Notes_markdown__xCZ-I"};